import * as React from 'react';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ImageLink from '../layouts/ImageLink';
import {isBrowser, isMobile } from 'react-device-detect';

import './style.css';
export default function Slider({elements=[], number_visible=1, gap=20, offset=1, scale=100}){

    const [position, setPosition] = React.useState(0);
    const one_width = Math.floor(scale/elements.length);

    const sliderStyle={
        width:(one_width*elements.length+gap).toString()+"vmax",
        gap:gap,
        left: position.toString()+"vmax",
    }
    
    return (
        <div className="flex-row" style={{justifyContent:"space-between", position:"relative",aligItems:"center", maxWidth:"100vw", paddingBottom:"3vh"}}>
            <div style={{height:"100%", margin:"auto"}}><button disabled={position>=0} onClick={()=>{
                setPosition(position+one_width)
            }} className="slider-button half-pillbox-right"><ArrowRightAltIcon style={{transform:"rotate(180deg)"}} className="slider-arrow"></ArrowRightAltIcon></button></div>
            <div className="slider-wrapper" >
            <div className="slider-body" style={sliderStyle}>
                {elements.map((element, index)=>{
                    return <div key={index} style={{position:"relative", width:one_width.toString()+"vmax", display:"flex", flexDirection:"column", justifyContent:"start"}}>{element}</div>
                })
                }
            </div>
            </div>
            <div  style={{height:"100%", margin:"auto"}}>
            <button style={{margin:"auto"}}  disabled={position<=-1*one_width*offset*number_visible}onClick={()=>{
                setPosition(position-one_width)
            }} className="half-pillbox-left slider-button"><ArrowRightAltIcon className="slider-arrow" ></ArrowRightAltIcon></button></div>
        </div>
    )
}